import { AuthModel } from './auth.model';

export class UserModel extends AuthModel {
  id: string;
  username: string;
  password: string;
  fullname: string;
  email: string;
  pic: string;
  nickName: string;
  confirmPassword: string;
  birthdate: Date;
  phone: number;
  favouriteColor: string;
  grade: number;
  state: string;
  secretWord: string;
  isOnline: boolean;

  setUser(user: any) {
    this.id = user.id;
    this.username = user.userName || '';
    this.password = user.password || '';
    this.fullname = user.fullname || '';
    this.email = user.email || '';
    this.pic = user.profilePictureUrl || 'assets/media/users/default.png';
    this.nickName = user.nickName;
    this.confirmPassword = user.confirmPassword;
    this.birthdate = user.birthdate;
    this.favouriteColor = user.favouriteColor;
    this.grade = user.grade;
    this.state = user.state;
    this.secretWord = user.secretWord;
    this.isOnline = user.isOnline;
  }
}

export class UserDataModel {
  id: string;
  userId: string;
  userName: string;
  email: string;
  roles: string[];
  jwToken: string;
  refreshToken: string;
  firstName: string;
  lastName: string;
  phone: string;
  birthDate: string;
  birthdate: string;
  state: string;
  favoriteColorCode: string;
  grade: number;
  profilePicture: string;
  profilePictureUrl: string;
  isOnline: boolean;
  isSurveyTaken: boolean;
}

export class UserUpdateDTO {
  userId: string;
  firstName: string; // required
  lastName: string; // required
  favoriteColorCode: string; // required
  birthdate: string; // required
  grade: number; // required
  state: string;
  phone: string;
  profilePicture: string;
  profilePictureFileName: string;
  admin?: 1 | 3;
}
